import { i18n } from 'I18n'

const i18nPathPrefix = 'common.validateFile'

const checkUploadedFile = (newFiles, restrictions) => {
    const filename = newFiles[0].name;
    const filesize = newFiles[0].size;

    let errorMessage = null
    let re = new RegExp("\\.(" + restrictions.fileExtensions.join('|') + ")$", "gi");

    if (!re.test(filename)) {
        if ((/\.doc$/gi).test(filename)) {
            errorMessage = i18n.t(`${i18nPathPrefix}.theDocFormatIsNotSupported`)
        }
        else {
            const formatterArguments = [filename.split(".").pop()];
            errorMessage = i18n.t(`${i18nPathPrefix}.fileExtension{0}IsNotSupported`, formatterArguments)
        }
    }
    else if (filesize > (restrictions.maxMbFileSize * 1024 * 1024)) {
        const formatterArguments = [restrictions.maxMbFileSize.toString()];
        errorMessage = i18n.t(`${i18nPathPrefix}."websiteSupportsLoadingNoMore{0}Mb`, formatterArguments)
    }

    return errorMessage
}

export default checkUploadedFile